import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import moment from "moment"

import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import auth from "@irati/auth"

import {Query} from "../"
import comment from "../../gql/comment"
import {commentFiltersToString} from "../../helpers/filtersToString"


const DEFAULT_PAGE_SIZE = 20

export const query = gql`
  query InsightsComments(
      $tenant: String!,
      $withTags: String,
      $filter: String,
      $sortBy: String,
      $sortDirection: String,
      $limit: Int,
      $offset: Int,
      $minCreatedAt: String,
      $maxCreatedAt: String,
      $withMessages: Boolean = false
    ) {
      insightsComments(
        tenant: $tenant,
        withTags: $withTags,
        filter: $filter,
        sortBy: $sortBy,
        sortDirection: $sortDirection,
        limit: $limit,
        offset: $offset,
        minCreatedAt: $minCreatedAt,
        maxCreatedAt: $maxCreatedAt
      ) {
        results {
          ${comment}
            messages @include(if: $withMessages) {
              results {
                roomUuid
              }
              total
            }
        }
        count
        total
        offset
      }
    }
`

const CommentsQuery = ({children, filters, tenant, page, cycle: {id: cycleId}, limit, sortDirection, ...props}) => {
  const {time} = filters
  const minCreatedAt = time ? moment(time).utc().format() : null
  const filter = commentFiltersToString({...filters, cycleId})

  const params = {
    withMessages: doIHavePermission(["insights.chatroom"], auth.apps()),
    withTags: "*",
    tenant,
    sortDirection,
    offset: page * limit,
    limit,
    filter,
    minCreatedAt
  }

  return (
    <Query
      {...props}
      variables={params}
      query={query}>
      {({data: {insightsComments: comments = []}, ...apolloState}) => {
        return children({comments, ...apolloState})
      }}
    </Query>
  )
}

CommentsQuery.propTypes = {
  children: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired,
  cycle: PropTypes.object.isRequired,
  page: PropTypes.number,
  limit: PropTypes.number,
  sortDirection: PropTypes.string
}

CommentsQuery.defaultProps = {
  page: 0,
  limit: DEFAULT_PAGE_SIZE,
  sortDirection: "desc"
}


export default CommentsQuery
